import clsx from 'clsx'

import ServiceFeatureCard from './ServiceFeatureCard'
import { assetUrl } from 'utils/url'
import { serviceFeatures } from 'app/RuangGtkHomePageV2/lib/constants'

import type { ServiceFeature } from 'app/RuangGtkHomePageV2/lib/constants'

// Group by category
const groupByCategory = (
  items: ServiceFeature[]
): Record<string, ServiceFeature[]> => {
  return items.reduce((acc: Record<string, ServiceFeature[]>, item) => {
    if (item.category) {
      if (!acc[item.category]) {
        acc[item.category] = []
      }
      acc[item.category].push(item)
    }
    return acc
  }, {})
}

const ruang = {
  name: 'GTK',
  title_color: 'inverse',
  title:
    'Sumber inspirasi peningkatan kompetensi serta kinerja Guru dan Tenaga Kependidikan (GTK)',
  button: 'Mulai Jelajahi Ruang GTK',
  color: '#2A7EFB',
  icon: assetUrl('/icons/ruang/gtk.svg'),
  banner: assetUrl('/images/ruang/bg-gtk.png'),
  button_target: '_blank',
}

const formatCategoryId = (category: string) =>
  `category-${category.replace(/\s+/g, '-').toLowerCase()}`

export function RuangGTK() {
  return (
    <section
      className="flex mx-auto w-full md:max-w-4xl lg:max-w-5xl xl:max-w-7xl 2xl:max-w-screen-2xl flex-col px-5 py-14 sm:px-8"
      aria-labelledby="services-heading"
    >
      <div className="w-full space-y-8">
        <h2
          id="services-heading"
          className="text-xl sm:text-2xl lg:text-3xl font-semibold"
        >
          Layanan yang Tersedia
        </h2>

        {Object.entries(groupByCategory(serviceFeatures)).map(
          ([category, features]) => (
            <section
              key={category}
              aria-labelledby={formatCategoryId(category)}
            >
              <h3
                id={`category-${formatCategoryId(category)}`}
                className="mb-4 text-lg sm:text-2xl lg:text-2xl font-semibold"
              >
                {category}
              </h3>
              <div className={clsx('flex flex-wrap gap-8')}>
                <div
                  className={clsx('flex flex-grow flex-col gap-6', 'lg:w-1/2')}
                >
                  <div
                    className={clsx(
                      'grid grid-cols-1 gap-4 overflow-y-auto pb-2',
                      'h-auto',
                      'sm:grid-cols-2 sm:gap-6 md:grid-cols-3 lg:grid-cols-4'
                    )}
                    role="region"
                    aria-label={`Daftar layanan ${category}`}
                  >
                    {features.map((feature, index) => (
                      <ServiceFeatureCard
                        feature={feature}
                        key={`specific-service-${index}`}
                        color={ruang.color}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </section>
          )
        )}
      </div>
    </section>
  )
}
